import { filterClasses } from "@swivl-mono/helpers";
import React from "react";

import { DEFAULT_AVATAR } from "../ImageUpload/ImageUploader";

interface Props {
  src?: string;
  className?: string;
  /**
   * Size utilities for the image, REPLACING the 40px default rather than
   * competing with it.
   *
   * A size passed through `className` cannot reliably win: both it and the
   * default are plain width/height utilities of equal specificity, so which one
   * applies comes down to the order Tailwind emits them, not the order they
   * appear in the attribute. Passing the size here means the default is never
   * emitted at all.
   */
  sizeClassName?: string;
}

export class Avatar extends React.Component<Props> {
  render() {
    const src = this.props.src || DEFAULT_AVATAR;
    return <img className={filterClasses("rounded-full", this.props.sizeClassName ?? "h-10 w-10", this.props.className)} src={src} alt="avatar" />;
  }
}

export class LocationAvatar extends React.Component<Props> {
  render() {
    const src = this.props.src || DEFAULT_AVATAR;
    return <img className={"h-10 w-10 rounded-xs " + (this.props.className || "")} src={src} alt="avatar" />;
  }
}
